import { LpCanvasElementComponent, LpCanvasMap, LpPlaceableMedia, LpRidLocation } from '../../typings/schema';

/** Builds the map of a location from a hand-made template map: the template's background and the location-bearing canvas components are swapped for the location's. Everything else (layout, back button, ...) is shared with the template, so all locations follow the template's design. */
export function buildLocationMap(template: LpCanvasMap, location: LpRidLocation): LpCanvasMap {
  return {
    ...template,
    uid: locationUid(template.uid, location),
    name: location.name,
    background: buildBackground(template.background, location),
    canvasElements: template.canvasElements.map((element) => ({
      ...element,
      components: element.components.map((component) => withLocation(component, location)),
    })),
  };
}

function buildBackground(templateBackground: LpPlaceableMedia, location: LpRidLocation): LpPlaceableMedia {
  return {
    dataType: 'ImagePlaceableMedia',
    uid: locationUid(templateBackground.uid, location),
    image: location.background,
    color: templateBackground.dataType === 'ImagePlaceableMedia' ? templateBackground.color : { r: 0, g: 0, b: 0, a: 0 },
  };
}

function withLocation(component: LpCanvasElementComponent, location: LpRidLocation): LpCanvasElementComponent {
  switch (component.dataType) {
    case 'RidLocationLabelCanvasComponent':
      return { ...component, uid: locationUid(component.uid, location), location };
    case 'RidLocationStopsCanvasComponent':
      return { ...component, uid: locationUid(component.uid, location), stops: location.stops };
    default:
      return component;
  }
}

// a uid per location, so nothing that caches by uid mixes up the locations
function locationUid(uid: string, location: LpRidLocation): string {
  return `${uid}:${location.uid}`;
}
